import React, { FC, useCallback } from 'react';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { deviceStatus } from 'api/Responses/DeviceResponses';
import AsyncImage from 'components/AsyncImage/AsyncImage';
import { useLanguage } from 'context/AppContext';
import useDevice from 'hooks/useDevice';
import { StorageType } from 'utils/helpers/image.helpers';
import { DraftTileButton, DraftTileContent, DraftTileImage, DraftTileName, DraftTileStatus } from '../DraftTile.styles';

interface DeviceDraftTileProps {
  id: string;
}

export const DeviceDraftTile: FC<DeviceDraftTileProps> = ({ id }) => {
  const navigate = useNavigate();
  const [language] = useLanguage();
  const { device, loading } = useDevice(id, false, false);

  const handleClick = useCallback(() => {
    navigate(`/device/${device.id}/edit`);
  }, [device.id, navigate]);

  return (
    <DraftTileButton onClick={handleClick}>
      <DraftTileContent>
        {!loading && (
          <DraftTileStatus status={deviceStatus[device.status]}>{language.DeviceStatus[device.status]}</DraftTileStatus>
        )}
        <DraftTileImage>
          {!loading && (
            <AsyncImage
              src={device.image}
              alt={device.id}
              imgWidth={18}
              imgHeight={11}
              storageType={StorageType.FIREBASE}
            />
          )}
        </DraftTileImage>
        <DraftTileName>
          <Typography component="strong">{device.id}</Typography>
          <Typography component="strong" sx={{ 'text-transform': 'none' }}>
            {device.owner_email}
          </Typography>
        </DraftTileName>
      </DraftTileContent>
    </DraftTileButton>
  );
};
